// You can customize the template with the help of this file
import { inIframe } from "@utils"
import { gima } from "gima-common"
//Template config options
const themeConfig = {
  app: {
    appName: `Mail Management`,
    appNameUnbreak: `Mail Management`,
    appLogoImage: require('@src/assets/images/logo/logo.png').default,
    appsilkReloLogo: gima.getTokenInfo('company_logo') || require('@src/assets/images/logo/logo.png').default
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: inIframe() ? 'static' : 'floating', // static , sticky , floating, hidden
      backgroundColor: gima.getThemeColor() || "#8dc454" // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  }
}

export default themeConfig
